import * as React from 'react'
import moment from 'moment'

import { DATE_FORMAT } from '@/app/constants/date'
import { getDayOfWeekName } from '@/app/common/dateHelper'
import { DayType } from '@/app/constants/dayType'
import { DAY_TYPE_BORDER_COLORS } from '@/modules/drivers/tabs/registry/schedule/constants/DayColors'

import BusinessTripTimelineNew from './BusinessTripTimelineNew'
import { BusinessTripDayChartProps } from '../types'

const NO_RING_DAY_TYPES: ReadonlySet<number> = new Set<number>([
  DayType.NONE,
  DayType.P,
  DayType.Ps,
  DayType.D,
  DayType.Prz,
  DayType.W,
  DayType.Wo,
  DayType.Pw,
  DayType.Sw,
  DayType.Wn,
  DayType.Wx,
  DayType.Ws,
  DayType.Xw,
  DayType.Xb,
  DayType.Xd,
  DayType.NoContract,
])


const BusinessTripDayChartNew: React.FC<BusinessTripDayChartProps> = (props) => {
  const { startTime, width, height, highlighted, notes, isLoading, translate } =
    props

  const dayNote = React.useMemo(
    () => notes?.find((n: any) => moment(n.date).isSame(startTime, 'day')),
    [notes, startTime],
  )

  const dayBorderColor = React.useMemo(() => {
    if (!dayNote) return null
    if (NO_RING_DAY_TYPES.has(dayNote.dayType)) return null
    return DAY_TYPE_BORDER_COLORS[dayNote.dayType] ?? null
  }, [dayNote])

  return (
    <div
      key={startTime.format(DATE_FORMAT)}
      className="tw-bg-white"
      style={{
        height: height,
        marginTop: 15,
        marginBottom: 15,
        borderStyle: 'solid',
        borderWidth: highlighted ? 2 : 0,
        borderColor: highlighted ? '#3B82F6' : 'transparent',
        borderRadius: highlighted ? '4px' : '0',
      }}
    >
      {width > 0 && !isLoading && (
        <div
          className="tw-flex tw-items-center"
          style={{ marginTop: 2, position: 'relative', height: height - 1 }}
        >
          <div
            className="tw-flex tw-shrink-0 tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-px-3"
            style={{
              width: 100,
              height: '100%',
              backgroundColor: 'var(--bt-day-col-bg, #fff)',
            }}
          >
            {dayNote && dayNote.dayType !== DayType.NONE && (
              <p className="tw-m-0 tw-w-full tw-text-center tw-text-xs tw-font-semibold tw-text-content-base">
                {DayType[dayNote.dayType]}
              </p>
            )}
            <p className="tw-m-0 tw-w-full tw-text-center tw-text-xs tw-font-medium">
              {translate(getDayOfWeekName(startTime))}
            </p>
            <p className="tw-m-0 tw-w-full tw-text-center tw-text-xs tw-text-gray-500">
              {startTime.format('DD.MM.YYYY')}
            </p>
          </div>
          <div className="tw-min-w-0 tw-flex-1">
            <BusinessTripTimelineNew
              id={startTime.format(DATE_FORMAT)}
              currentDate={startTime.format(DATE_FORMAT)}
              dayBorderColor={dayBorderColor}
              insertDelegationMarker={props.insertDelegationMarker}
              readonly={props.readonly}
              countries={props.countries}
              addEvent={props.addEvent}
              editEvent={props.editEvent}
              removeEvents={props.removeEvents}
              hideDelegationMarkerPopups={props.hideDelegationMarkerPopups}
              markNewEvent={props.markNewEvent}
              delegationMarkers={[...(props.events || [])]}
              allEvents={props.events || []}
              translate={translate}
              width={width}
              startTime={startTime}
              activities={props.activities}
              cardInserts={props.cardInserts}
              places={props.places}
              dayActivities={props.dayActivities}
              violations={props.violations}
              dailyRests={props.dailyRests}
              dailyPartialRegularRests={props.dailyPartialRegularRests}
              weeklyRests={props.weeklyRests}
              weeklyReducedRests={props.weeklyReducedRests}
              accomodations={props.accomodations}
              breaks={props.breaks}
              partialBreaks={props.partialBreaks}
              weekRecompenses={props.weekRecompenses}
              minimalPaymentCountries={props.minimalPaymentCountries}
              tmsData={props.tmsData}
              gpsPoints={props.gpsPoints}
              outOfScopes={props.outOfScopes}
              existingDelegations={props.existingDelegations}
              tripEvents={(props.tripEvents || []).filter(
                (e: any) => e.id != props.tripId,
              )}
              tripId={props.tripId}
              isRestsOnBaseModeOn={props.isRestsOnBaseModeOn}
              onRestClick={props.onRestClick}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default BusinessTripDayChartNew
